import {
  SupplierProductGetResponseChildType,
  SupplierProductGetResponseType,
} from "@sellar-io/api-v2/types";
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { Alert } from "../../../../../../components/alert/Alert";
import { Switch } from "@sellar-io/components";
import { apiV2AssertError } from "../../../../../../hooks/api/v2/apiV2Request";
import { useProductStatusUpdate } from "../../../../../../hooks/api/v2/product/useProductStatusUpdate";
import { useProductUpdate } from "../../../../../../hooks/api/v2/product/useProductUpdate";
import { InactiveParentProductDialog } from "../../../InactiveParentProductdialog/InactiveParentProductDialog";
import { ProductCategoryItemV2Setting } from "./ProductCategoryItemV2Setting";

export const ProductCategoryItemSwitches = ({
  parentActive,
  product,
  className,
}: {
  product: SupplierProductGetResponseChildType | SupplierProductGetResponseType;
  parentActive: boolean;
  className: string;
}) => {
  const productUpdateMutation = useProductUpdate(product.id);
  const productStatusUpdateMutation = useProductStatusUpdate(product.id);

  const [active, setActive] = useState(product.active);
  const [inactiveDialogActive, setInactiveDialogActive] =
    useState<boolean>(false);
  const [canBackorder, setCanBackorder] = useState(product.canBackorder);
  return (
    <>
      {(productUpdateMutation.isError ||
        productStatusUpdateMutation.isError) && (
        <Alert
          type={"error"}
          message={
            apiV2AssertError(
              productUpdateMutation.error ?? productStatusUpdateMutation.error,
            )?.response?.data.message ?? "Unknown error"
          }
        />
      )}
      <div className={twMerge(className)}>
        <ProductCategoryItemV2Setting title={"Visible on platform"}>
          <Switch
            checked={active}
            onChange={() => {
              if (parentActive) {
                setActive(!active);
                return productStatusUpdateMutation.mutate(
                  {
                    active: !active,
                  },
                  {
                    onSuccess: (updatedProduct) =>
                      setActive(updatedProduct.active),
                    onError: () => setActive(product.active),
                  },
                );
              }
              setInactiveDialogActive(true);
            }}
          />
        </ProductCategoryItemV2Setting>
        <ProductCategoryItemV2Setting title={"Allow backorders"}>
          <Switch
            checked={canBackorder}
            onChange={() => {
              setCanBackorder(!canBackorder);
              productUpdateMutation.mutate(
                {
                  canBackorder: !canBackorder,
                },
                {
                  onSuccess: (updatedProduct) =>
                    setCanBackorder(updatedProduct.canBackorder),
                  onError: () => setCanBackorder(product.canBackorder),
                },
              );
            }}
          />
        </ProductCategoryItemV2Setting>
      </div>
      <InactiveParentProductDialog
        active={inactiveDialogActive}
        onDismiss={() => setInactiveDialogActive(false)}
      />
    </>
  );
};
